import React from 'react';
import {NavLink} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import Context from '../context';

import Logo from '../assets/nav_logo.png';
import './adminTemplate/css/bootstrap.css';
import './adminTemplate/css/mdb.css';
import './adminTemplate/css/style.css';

const navbar = (props) => {
    let navBarInitial = null;
    let navBarUser = null;
    let navBarDirector = null;
    let navBarAdmin = null;
    let navBarInsertQuest = null;

    switch (true) {
        case(props.isAuth):
            switch (true) {
                case(props.isAdmin):
                    //console.log("Director Navbar");
                    navBarInitial = null;
                    navBarUser = null;
                    navBarDirector = null;
                    navBarInsertQuest = null;

                    navBarAdmin = (
                        <Context.Consumer>
                            {(context)=>(
                                <div>
                                    <nav className="navbar fixed-top navbar-expand-lg navbar-light white scrolling-navbar">
                                        <div className="container-fluid col-12">
                                            <a className="logo-wrapper waves-effect">
                                                <img src={Logo} className="d-inline-block align-top" alt="logo" width="110"/>
                                            </a>
                                            <ul className="navbar-nav nav-flex-icons">
                                                <NavLink to='/admin' activeClassName="active">
                                                    <button type="button" className="btn nav-item" onClick={context.sideBarSpecialChange}>
                                                        <i className="fas fa-user mr-2"/>E-cuidHaMUs
                                                    </button>
                                                </NavLink>
                                                <NavLink to='/' activeClassName="active">
                                                    <button type="button" className="btn nav-item" onClick={context.sideBarUserChange}>
                                                        <i className="fas fa-user mr-2" /><FormattedMessage id="user"/>
                                                    </button>
                                                </NavLink>
                                                <NavLink to='#' activeClassName="active">
                                                    <button type="button" className="btn nav-item" >
                                                        <i className="fas fa-user mr-2" /><FormattedMessage id="researcher"/>
                                                    </button>
                                                </NavLink>
                                                <NavLink to='#' activeClassName="active">
                                                    <button type="button" className="btn nav-item" >
                                                        <i className="fas fa-user mr-2" /><FormattedMessage id="makers"/>
                                                    </button>
                                                </NavLink>
                                                <NavLink to='/dashboard' activeClassName="active">
                                                    <button type="button" className="btn nav-item" onClick={context.sideBarAdminChange}>
                                                        <i className="fas fa-user mr-2" /><FormattedMessage id="admin"/>
                                                    </button>
                                                </NavLink>
                                                <li id="lispace" className="nav-item ml-10">
                                                    <a href='/logout' className="list-group-item list-group-item-action waves-effect">
                                                        <i className="fas fa-user mr-2"/>LogOut</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            )}
                        </Context.Consumer>
                    );
                    break;

                /*case(props.isQuest):
                    //profile is insertQuest
                    navBarInitial = null;
                    navBarUser = null;
                    navBarAdmin = null;
                    navBarDirector = null;

                    navBarInsertQuest = (
                        <div>
                            <nav className="navbar fixed-top navbar-expand-lg navbar-light white scrolling-navbar">
                                <div className="container-fluid col-12">
                                    <a className="logo-wrapper waves-effect">
                                        <img src={Logo} className="d-inline-block align-top" alt="logo" width="110"/>
                                    </a>
                                    <ul className="navbar-nav nav-flex-icons">
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Especial
                                            </NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>User</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Investigador</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Decisor</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Administrador</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item ml-10">
                                            <a href='/logout'
                                               className="list-group-item list-group-item-action waves-effect">
                                                <i className="fas fa-user mr-2"/>LogOut</a>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    );
                    break;
               case(props.isDirector):
                    //console.log("Director Navbar");
                    navBarInitial = null;
                    navBarUser = null;
                    navBarAdmin = null;
                    navBarInsertQuest = null;

                    navBarDirector = (
                        <div>
                            <nav className="navbar fixed-top navbar-expand-lg navbar-light white scrolling-navbar">
                                <div className="container-fluid col-12">
                                    <a className="logo-wrapper waves-effect">
                                        <img src={Logo} className="d-inline-block align-top" alt="logo" width="110"/>
                                    </a>
                                    <ul className="navbar-nav nav-flex-icons">
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Especial
                                            </NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>User</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Investigador</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Decisor</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#'
                                                     className="list-group-item list-group-item-action waves-effect"
                                                     activeClassName="active">
                                                <i className="fas fa-user mr-2"/>Administrador</NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item ml-10">
                                            <a href='/logout'
                                               className="list-group-item list-group-item-action waves-effect">
                                                <i className="fas fa-user mr-2"/>LogOut</a>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    );
                    break;*/
                default:
                    //console.log("User Navbar");
                    navBarInitial = null;
                    navBarDirector = null;
                    navBarAdmin = null;
                    navBarInsertQuest = null;

                    navBarUser = (
                        <div>
                            <nav className="navbar fixed-top navbar-expand-lg navbar-light white scrolling-navbar">
                                <div className="container-fluid col-12">
                                    <a className="logo-wrapper waves-effect">
                                        <img src={Logo} className="d-inline-block align-top" alt="logo" width="110"/>
                                    </a>
                                    <ul className="navbar-nav nav-flex-icons">
                                        <li id="lispace" className="nav-item">
                                            <NavLink to='#' className="list-group-item list-group-item-action waves-effect" activeClassName="active">
                                                <i className="fas fa-user mr-2"/><FormattedMessage id="user"/>
                                            </NavLink>
                                        </li>
                                        <li id="lispace" className="nav-item ml-10">
                                            <a href='/logout' className="list-group-item list-group-item-action waves-effect">
                                                <i className="fas fa-user mr-2"/>LogOut</a>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    );
                    break;
            }
        break;

        default:
            //console.log("Initial Navbar");
            navBarUser = null;
            navBarDirector = null;
            navBarAdmin = null;
            navBarInsertQuest = null;

            navBarInitial = (
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container">
                        <NavLink to={'/'} className="no-decoration">
                            <span className="navbar-brand"><img src={Logo} className="d-inline-block align-top"
                                                                alt="logo" width="110"/></span>
                        </NavLink>
                        <button className="navbar-toggler p-0 border-0" type="button" data-toggle="collapse"
                                data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault"
                                aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"/>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarsExampleDefault">
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <NavLink to={'/login'} className="no-decoration">
                                        <span className="nav-link">
                                            <FormattedMessage id="login"/>
                                        </span>
                                    </NavLink>
                                </li>
                                <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <NavLink to={'/register'} className="no-decoration">
                                        <span className="nav-link">
                                            <FormattedMessage id="register"/>
                                        </span>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            );
            break;
    }
    return (
        <header>
            {navBarInitial}
            {navBarUser}
            {navBarDirector}
            {navBarAdmin}
            {navBarInsertQuest}
        </header>
    )
};

export default navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js